import { createSlice } from "@reduxjs/toolkit";
import { createErrorReportingAsyncThunk } from "../../helpers";
import { CargoType } from "dora-contracts";
import { apiFetch } from "../../../helpers/api-fetch";

type State = {
  types: CargoType[];
};

const initialState: State = {
  types: [],
};

export const loadCargoTypes = createErrorReportingAsyncThunk(
  "data/cargo-types/load",
  async () => {
    const result = await apiFetch("/web-booking-api/cargo-types");
    if (!result.ok) {
      throw new Error("Error loading cargo types");
    }
    const data = (await result.json()) as { cargoTypes: CargoType[] };
    return data.cargoTypes;
  }
);

const slice = createSlice({
  name: "data/cargo-types",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadCargoTypes.fulfilled, (state, action) => {
      state.types = action.payload;
    });
  },
});

export const selectCargoTypes = (state: {
  data: { cargoTypes: State };
}): CargoType[] => state.data.cargoTypes.types;

export default slice.reducer;
